<div class="card">
    <p-accordion [multiple]="false" (activeIndexChange)="handleOnOpen($event)" #authAccordions>
        <p-accordionTab header="Sync Pay Rates">
            <form [formGroup]="syncFormGroup" #addForm="ngForm" id="addForm">

                <p-toolbar>
                    <div>
                        <button id="btnClearFilters" class="btn btn-link" type="button" aria-label="Clear Filter"
                            #clearFilters label="Clear">
                            Clear
                        </button>
                    </div>
                    <!-- Employee -->
                    <div>
                        <p-floatLabel variant="on">
                            <p-multiSelect #employee [style]="{ width: '100%', 'min-width': '10em' }"
                                [virtualScroll]="true" [itemSize]="dropdownItemHeight"
                                [options]="activeDirectReportsSelectItems" formControlName="EmployeeListID"
                                appendTo="body" [filter]="true"
                                (onChange)="onDirectReportChange($event)"></p-multiSelect>
                            <label for="float-dd">Employee</label>
                        </p-floatLabel>
                    </div>
                    <!-- payroll item -->
                    <div *ngIf="false">
                        <p-floatLabel variant="on">
                            <p-select #payrollItem [style]="{ width: '100%' }" [virtualScroll]="true"
                                [itemSize]="dropdownItemHeight" [options]="filteredPayrollItemsSelectItems"
                                [autoDisplayFirst]="false" appendTo="body" formControlName="PIListID"
                                [filter]="true"></p-select>
                            <label for="float-dd">Payroll Item</label>
                        </p-floatLabel>
                    </div>
                    <!-- From Pay period -->
                    <div>
                        <p-floatLabel variant="on">
                            <p-select #employee [style]="{ 'min-width': '11em', width: '100%' }" [virtualScroll]="true"
                                [itemSize]="dropdownItemHeight" [options]="payperiodSelectItems"
                                [autoDisplayFirst]="false" formControlName="FromDates" appendTo="body"
                                [filter]="true"></p-select>
                            <label for="float-dd">From Pay Period</label>
                        </p-floatLabel>
                    </div>
                    <!-- To Pay period range-->
                    <!-- start date -->
                    <div style="flex-basis: 12.5rem;">
                        <p-floatLabel variant="on">
                            <p-select #toStartDate [style]="{ width: '100%' }" [virtualScroll]="true"
                                [itemSize]="dropdownItemHeight" [options]="
                                startDatesSelectItems
                                    | filterBy
                                        : (toEndDate.value
                                            ? 'x => new Date(x.value) < new Date(\'' +
                                                toEndDate.value +
                                                '\')'
                                            : 'x => true')
                            " [autoDisplayFirst]="false" appendTo="body" formControlName="StartDate"
                                [filter]="true"></p-select>
                            <label for="float-dd">To Pay Period Start</label>
                        </p-floatLabel>
                    </div>
                    <!-- end date-->
                    <div style="flex-basis: 12.5rem;">
                        <p-floatLabel variant="on">
                            <p-select #toEndDate [style]="{ width: '100%' }" [virtualScroll]="true"
                                [itemSize]="dropdownItemHeight" [options]="
                                endDatesSelectItems
                                    | filterBy
                                        : (toStartDate.value
                                            ? 'x => new Date(x.value) > new Date(\'' +
                                                toStartDate.value +
                                                '\')'
                                            : 'x => true')
                            " [autoDisplayFirst]="false" appendTo="body" formControlName="EndDate"
                                defaultLabel="To End Date" [filter]="true"></p-select>
                            <label for="float-dd">To Pay Period End</label>
                        </p-floatLabel>
                    </div>
                    <!-- sync Pay period -->
                    <button #syncPayperiod pButton type="button" class="p-button-secondary" aria-label="Sync pay period"
                        [disabled]="
                        selected.length ||
                        syncFormGroup.controls['FromDates'].invalid ||
                        syncFormGroup.controls['StartDate'].invalid ||
                        syncFormGroup.controls['EndDate'].invalid ||
                        syncFormGroup.controls['EmployeeListID'].invalid
                    " icon="pi pi-refresh" label="Sync from Pay period"></button>
                </p-toolbar>
            </form>
            <div>
                <p-messages [value]="formAddErrors"> </p-messages>
            </div>
        </p-accordionTab>
        <p-accordionTab header="Update Multiple Pay Rates">
            <div class="helpText">
                <ol>
                    <li>
                        Select the employee and payroll item in the grid below, for
                        salary employees only one item is required
                    </li>
                    <li>Enter pay rate change</li>
                    <li>Click Update</li>
                </ol>
            </div>
            <form [formGroup]="updateFormGroup" #addForm="ngForm" id="updateForm">
                <p-toolbar>

                    <div>
                        <p-floatLabel variant="on">
                            <input [disabled]="!selected.length" pInputText type="text" aria-label="Pay Rate"
                                formControlName="PayRate" />
                            <label for="float-dd">Pay Rate</label>
                        </p-floatLabel>
                    </div>

                    <button *ngIf="false" pButton type="button" class="p-button-secondary"
                        aria-label="Copy Payrate History" [disabled]="!selected.length || syncFormGroup.dirty"
                        #copyItems icon="pi pi-pencil" label="Copy"></button>

                    <button pButton type="button" class="p-button-secondary" aria-label="Update Payrate History"
                        [disabled]="
                        !selected.length ||
                        selected.some(hasErrorStatus) ||
                        updateFormGroup.invalid
                    " #updateItems icon="pi pi-pencil" label="Update"></button>

                    <button *ngIf="false" #deleteItems pButton type="button" class="p-button-danger"
                        aria-label="Delete Payrate History" [disabled]="!selected.length" icon="pi pi-trash"
                        label="Delete"></button>
                </p-toolbar>
            </form>
        </p-accordionTab>
        <p-panel disabled header="Pay Rate History">
            <div class="scroll-container">
                <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
                    <p-toolbar>
                        <!-- start date -->
                        <div>
                            <p-floatLabel variant="on">
                                <p-select #startDate [style]="{ width: '100%' }" [virtualScroll]="true"
                                    [itemSize]="dropdownItemHeight" [options]="
                                startDatesSelectItems
                                    | filterBy
                                        : (endDate.value
                                              ? 'x => new Date(x.value) < new Date(\'' +
                                                endDate.value +
                                                '\')'
                                              : 'x => true')
                            " [autoDisplayFirst]="false" appendTo="body" formControlName="StartDate"
                                    defaultLabel="Start Date" [filter]="true"></p-select>
                                <label for="float-dd">Pay Period Start</label>
                            </p-floatLabel>
                        </div>
                        <!-- end date-->
                        <div>
                            <p-floatLabel variant="on">
                                <p-select #endDate [style]="{ width: '100%' }" [virtualScroll]="true"
                                    [itemSize]="dropdownItemHeight" [options]="
                                endDatesSelectItems
                                    | filterBy
                                        : (startDate.value
                                              ? 'x => new Date(x.value) > new Date(\'' +
                                                startDate.value +
                                                '\')'
                                              : 'x => true')
                            " [autoDisplayFirst]="false" appendTo="body" formControlName="EndDate"
                                    defaultLabel="End Date" [filter]="true"></p-select>
                                <label for="float-dd">Pay Period End</label>
                            </p-floatLabel>
                        </div>
                        <div>
                            <button pButton id="applyMulti" label="Filter" icon="pi pi-filter"
                                class="p-button-secondary" iconPos="left" title="Filter" #applyMulti (click)="
                            this.Filter.next({
                                StartDate: startDate.value,
                                EndDate: endDate.value
                            })
                        "></button>
                        </div>
                    </p-toolbar>
                </form>
                <p-table stripedRows #dataTable [value]="items" dataKey="id" editMode="row" [style]="{ 'min-width': '115em' }"
                    [(selection)]="selected" (onRowSelect)="onRowSelect($event)" [scrollable]="true"
                    [scrollHeight]="'58vh'" scrollDirection="both" [virtualRowHeight]="27" [virtualScroll]="true">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="13" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="13" style="text-align: center">
                                <div>
                                    Loading...<i class="fa fa-spinner fa-spin"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template #header let-item>
                        <tr>
                            <!-- Edit -->
                            <th class="edit-cell"></th>
                            <!-- Status-->
                            <th class="status-cell">
                                <i class="pi pi-exclamation-circle" title="Status"></i>
                            </th>
                            <!-- Selection -->
                            <th class="select-cell">
                                <p-tableHeaderCheckbox *ngIf="!editing"></p-tableHeaderCheckbox>
                            </th>
                            <!-- User -->
                            <th pSortableColumn="EmployeeName">
                                Name
                                <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="EmployeeName" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="usersFilterSelectItems" [filter]="true"
                                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Pay Type -->
                            <th pSortableColumn="PayrollItemType">
                                Pay Type
                                <p-sortIcon field="PayrollItemType" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="PayrollItemType" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="
                                        payrollItemTypesFilterSelectItems
                                    " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Payroll Item -->
                            <th pSortableColumn="PayrollItem">
                                Payroll Item
                                <p-sortIcon field="PayrollItem" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter field="PayrollItem" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="payrollItemsFilterSelectItems" [filter]="true"
                                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Start Date -->
                            <th pSortableColumn="StartDate">
                                Start Date
                                <p-sortIcon field="StartDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- End Date -->
                            <th pSortableColumn="EndDate">
                                End Date
                                <p-sortIcon field="EndDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Pay Rate -->
                            <th pSortableColumn="PayRate">
                                Pay Rate
                                <p-sortIcon field="PayRate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Hourly Rate -->
                            <th pSortableColumn="HourlyRate"
                                title="For salary employees, this is the rate used for total time accounting which reflects salary undertime/overtime.">
                                Hourly Rate
                                <p-sortIcon field="HourlyRate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Admin Added -->
                            <th pSortableColumn="IsManual">
                                Admin Added
                                <p-sortIcon field="IsManual" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Modified Date -->
                            <th pSortableColumn="MaintDate">
                                Modified Date
                                <p-sortIcon field="MaintDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Modified By -->
                            <th pSortableColumn="ModifiedBy">
                                Modified By
                                <p-sortIcon field="ModifiedBy" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <!-- Delete -->
                            <th class="delete-cell">
                                <i class="pi pi-trash"></i>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
                        <tr [pSelectableRow]="item" [pEditableRow]="item" data-id="row-{{ item.id }}" [ngClass]="{
                            'ui-editing-row': edit && editing?.id === item?.id
                        }">
                            <!-- Edit -->
                            <td style="
                                width: 6em;
                                text-align: center;
                                vertical-align: middle;
                            " class="p-datatable-cell edit-cell">

                                <button *ngIf="item?.id === -99 && !edit" pButton type="button" pInitEditableRow
                                    icon="pi pi-plus" class="p-button-rounded p-button-text p-button-success"
                                    (click)="onRowEditInit(item)"></button>
                                <button *ngIf="
                                        !edit &&
                                        (!editing?.id ||
                                            editing?.id === item?.id) &&
                                        item?.id !== -99 &&
                                        selected.length < 2
                                    " pButton type="button" pInitEditableRow icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text" (click)="onRowEditInit(item)"
                                    title="Edit"></button>
                                <button *ngIf="edit" pButton type="button" pSaveEditableRow icon="pi pi-check"
                                    class="p-button-rounded p-button-text p-button-success"
                                    (click)="onRowEditSave(item)"></button>
                                <button *ngIf="edit" pButton type="button" pCancelEditableRow icon="pi pi-times"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    (click)="onRowEditCancel(item)"></button>
                            </td>
                            <!-- Status-->
                            <td class="status-cell">
                                <div (click)="onStatusClick(item)" class="status-cell">
                                    <ef-status-icon [status]="item?.Status?.StatusCode"
                                        [message]="item?.Status?.Message"></ef-status-icon>
                                </div>
                            </td>
                            <!-- Selection -->
                            <td class="select-cell">
                                <p-tableCheckbox [value]="item" *ngIf="!editing"></p-tableCheckbox>
                            </td>

                            <!-- User -->
                            <td [ngClass]="{ disabled: 'item?.id > -99' }" [title]="item?.EmployeeName">
                                {{ item?.EmployeeName }}
                            </td>
                            <!-- Pay Type -->
                            <td class="disabled" [title]="item?.PayrollItemType">
                                {{ item?.PayrollItemType }}
                            </td>
                            <!-- PayrollItem -->
                            <td class="disabled" [title]="item?.PayrollItem">
                                {{ item?.PayrollItem }}
                            </td>
                            <!-- Start Date -->
                            <td class="disabled" [title]="
                                moment(item?.StartDate).isValid()
                                    ? moment(item?.StartDate).format(
                                          'MM/DD/YYYY'
                                      )
                                    : ''
                            ">
                                <p-cellEditor>
                                    <ng-template *ngIf="item.id === -99" pTemplate="input">
                                        <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                                            [maxDate]="item?.EndDate" yearRange="2000:2030" [(ngModel)]="item.StartDate"
                                            appendTo="body"></p-calendar>
                                    </ng-template>
                                    <ng-template *ngIf="item.id !== -99" pTemplate="input">
                                        {{
                                        moment(item?.StartDate).isValid()
                                        ? moment(item?.StartDate).format(
                                        'MM/DD/YYYY'
                                        )
                                        : ''
                                        }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        moment(item?.StartDate).isValid()
                                        ? moment(item?.StartDate).format(
                                        'MM/DD/YYYY'
                                        )
                                        : ''
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- End Date -->
                            <td class="disabled" [title]="
                                moment(item?.EndDate).isValid()
                                    ? moment(item?.EndDate).format('MM/DD/YYYY')
                                    : ''
                            ">
                                <p-cellEditor>
                                    <ng-template *ngIf="item.id === -99" pTemplate="input">
                                        <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                                            [minDate]="item?.StartDate" yearRange="2000:2030" [(ngModel)]="item.EndDate"
                                            appendTo="body"></p-calendar>
                                    </ng-template>
                                    <ng-template *ngIf="item.id !== -99" pTemplate="input">
                                        {{
                                        moment(item?.EndDate).isValid()
                                        ? moment(item?.EndDate).format(
                                        'MM/DD/YYYY'
                                        )
                                        : ''
                                        }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                        moment(item?.EndDate).isValid()
                                        ? moment(item?.EndDate).format(
                                        'MM/DD/YYYY'
                                        )
                                        : ''
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Pay Rate -->
                            <td class="currency" [title]="item?.PayRate">
                                <p-cellEditor>
                                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                        <input pInputText [(ngModel)]="item.PayRate" />
                                    </ng-template>
                                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                        {{ item?.PayRate | currency }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item?.PayRate | currency }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Hourly Rate -->
                            <td class="currency" [title]="item?.HourlyRate | number:'1.2-4'">
                                {{ item?.HourlyRate | number:'1.2-4'}}
                            </td>
                            <!-- Admin Added -->
                            <td class="disabled" [title]="item?.IsManual === true">
                                <i *ngIf="item?.IsManual" class="pi pi-check green"></i>
                            </td>
                            <!-- Modified Date -->
                            <td class="disabled" [title]="
                                moment(item?.MaintDate).isValid()
                                    ? moment(item?.MaintDate).format(
                                          'MM/DD/YYYY'
                                      )
                                    : ''
                            ">
                                {{
                                moment(item?.MaintDate).isValid()
                                ? moment(item?.MaintDate).format(
                                'MM/DD/YYYY'
                                )
                                : ''
                                }}
                            </td>
                            <!-- Modified By -->
                            <td class="disabled" [title]="item?.ModifiedBy">
                                {{ item?.ModifiedBy }}
                            </td>
                            <!-- Delete -->
                            <td class="delete-cell">
                                <button *ngIf="
                                    item?.id !== 'add' &&
                                    !edit &&
                                    item.IsManual === true
                                " pButton type="button" pSaveEditableRow icon="pi pi-trash"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    (click)="onRowEditDelete(item, ri)" style="font-size: 0.65rem"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-panel>
    </p-accordion>
</div>
